import React, { useEffect, useMemo, useRef, useState } from "react";
import { View, Image } from "react-native";
import { LogoAnimation } from "../../../assets";

const ATLAS_WIDTH = 2000;
const ATLAS_HEIGHT = 1680;

const COLS = 5;
const ROWS = 5;

const FRAME_WIDTH = ATLAS_WIDTH / COLS;
const FRAME_HEIGHT = ATLAS_HEIGHT / ROWS;

const SCALE = 0.8;

const LoginLogoWeb = () => {
  const FRAME_SEQUENCE = useMemo(
    () => [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22, // ✅ freeze target exists
    ],
    [],
  );

  const FREEZE_FRAME = 20;

  // ✅ find where in the sequence is frame 22
  const freezeIndex = FRAME_SEQUENCE.indexOf(FREEZE_FRAME);

  // ✅ if for some reason it isn't in the list, fallback to last item
  const FINAL_INDEX =
    freezeIndex !== -1 ? freezeIndex : FRAME_SEQUENCE.length - 1;

  const [seqIndex, setSeqIndex] = useState(0);

  // ✅ IMPORTANT: prevents double interval in dev/StrictMode
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (intervalRef.current) {
      return;
    }

    intervalRef.current = setInterval(() => {
      setSeqIndex((i) => {
        if (i >= FINAL_INDEX) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }

          return FINAL_INDEX;
        }

        return i + 1;
      });
    }, 140);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [FINAL_INDEX]);

  const frame = FRAME_SEQUENCE[seqIndex];

  const col = frame % COLS;
  const row = Math.floor(frame / COLS);

  const left = -col * FRAME_WIDTH;
  const top = -row * FRAME_HEIGHT;

  return (
    <View
      style={{
        width: FRAME_WIDTH * SCALE,
        height: FRAME_HEIGHT * SCALE,
        overflow: "hidden",
        backgroundColor: "transparent",
      }}
    >
      <Image
        source={LogoAnimation}
        style={{
          width: ATLAS_WIDTH * SCALE,
          height: ATLAS_HEIGHT * SCALE,
          left: left * SCALE,
          top: top * SCALE,
          position: "absolute",
        }}
        resizeMode="stretch"
      />
    </View>
  );
};

export default LoginLogoWeb;
